export default "__VITE_ASSET__CVKiqtKF__"